<template>
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M16.219 5.672a2.813 2.813 0 1 0 5.625 0 2.813 2.813 0 0 0-5.625 0ZM17.449 19.734l.176 1.407h2.813l.703-5.625h1.406v-2.11a3.515 3.515 0 0 0-5.625-2.812M2.156 5.672a2.812 2.812 0 1 0 5.625 0 2.812 2.812 0 0 0-5.625 0ZM6.551 19.734l-.176 1.407H3.562l-.703-5.625H1.453v-2.11a3.516 3.516 0 0 1 5.625-2.812M9.89 9.188a2.11 2.11 0 1 0 4.22 0 2.11 2.11 0 0 0-4.22 0ZM12 12.703a3.516 3.516 0 0 0-3.516 3.516v.703h1.407l.703 4.219H12M12 12.703a3.516 3.516 0 0 1 3.516 3.516v.703h-1.407l-.703 4.219H12"
    />
  </svg>
</template>
